import {Pipe, PipeTransform} from '@angular/core';
import {TrackerMetricTypes} from './tracker-metric-types';

@Pipe({
  name: 'trackerMetricTypeDisplay',
  standalone: true,
})
export class TrackerMetricTypeDisplayPipe implements PipeTransform {
  transform(value: TrackerMetricTypes): string {
    switch (value) {
      case TrackerMetricTypes.Numeric:
        return 'Number';
      case TrackerMetricTypes.Select:
        return 'List';
      case TrackerMetricTypes.Boolean:
        return 'Yes / No';
      case TrackerMetricTypes.Text:
        return 'Text';
      case TrackerMetricTypes.Photo:
        return 'Photo';
      case TrackerMetricTypes.Duration:
        return 'Duration';
      default:
        return 'Unknown';
    }
  }
}
